// @ts-nocheck

(function () {
  const MOBILE_DRAWER_BREAKPOINT = '(max-width: 968px)';

  function isMobileRequirementsSheet() {
    return (
      typeof window !== 'undefined' &&
      window.matchMedia &&
      window.matchMedia(MOBILE_DRAWER_BREAKPOINT).matches
    );
  }

  function ensureMobileDrawerBackdrop() {
    let backdrop = document.getElementById('mobile-drawer-backdrop');
    if (backdrop) return backdrop;

    backdrop = document.createElement('div');
    backdrop.id = 'mobile-drawer-backdrop';
    backdrop.className = 'mobile-drawer-backdrop';
    backdrop.addEventListener('click', () => {
      window.closeMobileOverlayFromBackdrop?.();
    });
    document.body.appendChild(backdrop);
    return backdrop;
  }

  function populateRequirementsMobileDrawer(productTitle, variantData) {
    const drawer = document.getElementById('mobile-drawer-requirements');
    if (!drawer || typeof window.cmrpBuildRequirementsTable !== 'function') {
      return false;
    }

    const { table, publisher_name, ebook_format } =
      window.cmrpBuildRequirementsTable(variantData);

    const subtitleEl = drawer.querySelector('#requirements-drawer-subtitle');
    const tableHost = drawer.querySelector('#requirements-drawer-table');

    if (subtitleEl) {
      subtitleEl.textContent = window.cmrpBuildRequirementsSubtitle(
        productTitle,
        publisher_name,
        ebook_format
      );
    }

    if (tableHost) {
      tableHost.innerHTML = '';
      tableHost.appendChild(table);
    }

    const body = drawer.querySelector('#requirements-drawer-body');
    if (body && typeof window.cmrpBuildRequirementsAnnouncement === 'function') {
      body.setAttribute(
        'aria-label',
        window.cmrpBuildRequirementsAnnouncement(
          subtitleEl?.textContent || '',
          table
        )
      );
    }

    return true;
  }

  function openRequirementsMobileDrawer(productTitle, variantData) {
    if (!populateRequirementsMobileDrawer(productTitle, variantData)) return false;

    ensureMobileDrawerBackdrop();

    if (
      window.courseMaterialsSidebar &&
      typeof window.courseMaterialsSidebar.openMobileDrawerById === 'function'
    ) {
      window.courseMaterialsSidebar.openMobileDrawerById('mobile-drawer-requirements');
      document
        .getElementById('requirements-drawer-body')
        ?.focus({ preventScroll: true });
      return true;
    }

    const drawer = document.getElementById('mobile-drawer-requirements');
    const backdrop = document.getElementById('mobile-drawer-backdrop');
    if (!drawer || !backdrop) return false;

    backdrop.classList.add('show');
    drawer.classList.add('mobile-drawer-open');
    drawer.style.transform = 'translateY(0)';
    document.body.style.overflow = 'hidden';
    document.documentElement.classList.add('cmrp-scroll-lock');
    drawer.querySelector('#requirements-drawer-body')?.focus({ preventScroll: true });
    return true;
  }

  function closeRequirementsMobileDrawer() {
    const drawer = document.getElementById('mobile-drawer-requirements');
    const backdrop = document.getElementById('mobile-drawer-backdrop');

    if (drawer) {
      drawer.classList.remove('mobile-drawer-open');
      drawer.style.transform = 'translateY(100%)';
    }

    if (backdrop) {
      backdrop.classList.remove('show', 'mobile-drawer-backdrop--access');
    }

    document.body.style.overflow = '';
    document.documentElement.classList.remove('cmrp-scroll-lock');
    window.courseMaterialsMobile?.syncMobileDrawerBodyScroll?.();
  }

  function closeMobileOverlayFromBackdrop() {
    const requirementsDrawer = document.getElementById('mobile-drawer-requirements');
    if (requirementsDrawer?.classList.contains('mobile-drawer-open')) {
      closeRequirementsMobileDrawer();
      return;
    }
    window.courseMaterialsSidebar?.closeMobileDrawer?.();
  }

  window.isMobileRequirementsSheet = isMobileRequirementsSheet;
  window.openRequirementsMobileDrawer = openRequirementsMobileDrawer;
  window.closeRequirementsMobileDrawer = closeRequirementsMobileDrawer;
  window.closeMobileOverlayFromBackdrop = closeMobileOverlayFromBackdrop;

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const drawer = document.getElementById('mobile-drawer-requirements');
    if (drawer?.classList.contains('mobile-drawer-open')) {
      closeRequirementsMobileDrawer();
    }
  });
})();
